<template lang="pug">
  app-page(title="Мои заявки" :fab-items="items")
    listToolbar

    addAdvocatApp(v-model="dialogAddAdvocatApp")

    div
      v-layout(row wrap v-if="appList.length > 0")
        v-flex.px-4(xs4 v-for="(a, index) in appList" :key="index" )
          advocatAppCard(@click.native="showAppDetail(a)" :advocatApp="a" :fromAdvocat="true")
    
    app-empty-list(v-if="isAppsLoaded && appList.length == 0")
      div Не найдено ни одной заявки
      div Со статусом: {{ selectedStatus | statusNamed }}
      div За период: {{ period | periodNamed }}

</template>

<script>
import { AppToolbarItemDivider } from '@/components'
import addAdvocatApp from './components/AddAdvocatApp'
import advocatAppCard from './components/AdvocatAppCard'
import listToolbar from './components/ListToolbar'
import moment from 'moment'
moment.locale('ru');

import { $_app_moment } from "@/common/AppMoment.js"

import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  mixins: [ $_app_moment ],
  components: {
    addAdvocatApp, 
    listToolbar,
    advocatAppCard
  },

  methods: {
    ...mapMutations('advocat', ['setAppsStatus']),
    showAppDetail(selectedApp) {
      this.$router.push({name: 'AdvocatAppDetail', params: {appId: selectedApp.id}})
    },
  },

  data() {
    return {
      dialogAddAdvocatApp: false,
    }
  },

  filters: {
    statusNamed: status => {
      return status != null ? status.title : 'Все'
    },
    periodNamed: function (period) {
      return period != null ? period.text : 'Все'
    },
  },


  computed: {
    ...mapState('advocat', ['selectedStatus', 'selectedJudge', 'period']),
    ...mapGetters('specialist', ['specialist']),
    ...mapGetters('advocat', ['apps','isAppsLoaded']),

    items () {
      return this.specialist && this.specialist.moderated 
      ? [AppToolbarItemDivider, { icon:'sud-add-icon sud-add-message', title:'заявку на оплату', action: () => this.dialogAddAdvocatApp = true }] 
      : []
    },

    appList() {
      let list = (this.selectedStatus == null) ? this.apps : this.apps.filter(c => c.appStatus.value == this.selectedStatus.value)
      list = (this.selectedJudge == null) ? list : list.filter(c => c.courtCase.judge.id == this.selectedJudge.id)

      if (this.period) {
        list = list.filter(item => moment(item.createDate).isBetween(this.period.start, this.period.end, 'day', '[]'))
      }

      return list
    }
  },
  created() {
    this.$store.dispatch('advocat/INIT')
  }
}

</script>

<style scoped>
</style>
